import React from 'react';
import * as R from 'ramda';
import { Counter } from 'models.market';
import { Tooltip } from 'Components/nui';
import { FormattedMessage } from 'react-intl';

export const CounterSummaryTooltip = ({
  counters,
  children,
}: Record<'counters', Counter[]> & Record<'children', React.ReactNode>) => {
  const isActive = R.either(
    R.propEq('status', 'Working'),
    R.propEq('status', 'Oversubscribed')
  );
  const activeCounters = R.filter(isActive, counters);
  const declinedCounters = R.filter(R.propEq('status', 'Declined'), counters);
  const tradedCounters = R.filter(R.propEq('status', 'Traded'), counters);
  const cancelledCounters = R.filter(R.propEq('status', 'Cancelled'), counters);
  return (
    <Tooltip
      title={
        <span className="icon-tooltip">
          <span className="icon-info-circled" />
          <FormattedMessage
            id="counter-summary-tooltip-intro"
            defaultMessage="This order has"
          />{' '}
          <ul className="counters-summary-list">
            {activeCounters.length ? (
              <li key="activeCounter">
                <FormattedMessage
                  id="counter-summary-tooltip-active"
                  defaultMessage="{count} active {count, plural, one {counter} other {counters}}"
                  values={{ count: activeCounters.length }}
                />
              </li>
            ) : null}
            {declinedCounters.length ? (
              <li key="declinedCounter">
                <FormattedMessage
                  id="counter-summary-tooltip-declined"
                  defaultMessage="{count} declined {count, plural, one {counter} other {counters}}"
                  values={{ count: declinedCounters.length }}
                />
              </li>
            ) : null}
            {tradedCounters.length ? (
              <li key="tradedCounter">
                <FormattedMessage
                  id="counter-summary-tooltip-traded"
                  defaultMessage="{count} traded {count, plural, one {counter} other {counters}}"
                  values={{ count: tradedCounters.length }}
                />
              </li>
            ) : null}
            {cancelledCounters.length ? (
              <li key="cancelledCounter">
                <FormattedMessage
                  id="counter-summary-tooltip-withdrawn"
                  defaultMessage="{count} withdrawn {count, plural, one {counter} other {counters}}"
                  values={{ count: cancelledCounters.length }}
                />
              </li>
            ) : null}
          </ul>
        </span>
      }
    >
      {children}
    </Tooltip>
  );
};
